// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9v-0";
export var orangeButton = "_9v-1";